/**
 * This is used to display Menu dropdowns like the Profile Menu in the
 * MeatballProfileLayout Component.
 * We might want to consider renaming this component as it might be confused
 * with the 'ComboButton' component which is the actual button attached to the
 * DropDown/index.js component.
 */
import { createElement, useMemo } from 'react';
import {
    Menu,
    Button,
    fromTheme,
    webOnlyStyles,
    nativeOnlyStyles,
    MenuDivider,
    MenuHeader,
    styled
} from 'lib_ui-primitives';
import MenuItem from './MenuItem';

const rc = createElement;

// most styling on this will NOT make ANY difference
let MenuStyle = styled(Menu).attrs(({ theme }) => ({
    gap: theme?.menu?.actionMenu?.offsetTop ?? 0
}))``;

MenuStyle = webOnlyStyles(MenuStyle)`
    list-style-type: none;
`;

// to some extend, this styling gets applied to the actual displayed menu,
// even though this is NOT the actual Menu component used for rendering the menu
// However, it does NOT affect the outermost part of the menu.
// that comes from createGlobalStyle.js
MenuStyle = nativeOnlyStyles(MenuStyle)`
    margin-top: ${fromTheme('menu', 'native', 'marginTop')};
    padding-top: ${fromTheme('menu', 'native', 'paddingTop')};
    margin-left:8px;
`;

MenuStyle.displayName = 'MenuStyle';

const DropDownButton = ({ id, children = null, icon, size, color, className, menuClassName = '', buttonStyle = 'round', ...otherProps }) => {
    // Memoize the button per-render, re-creating only when key props change (including size for theme switching)
    const menuButton = useMemo(
        () => rc(Button, { buttonStyle, icon, size, color, className, ...otherProps, id: `menu-button-${id}` }),
        [id, icon, size, color, buttonStyle, className, otherProps]
    );
    // prettier-ignore
    return rc(MenuStyle, {
        direction: 'bottom',
        menuButton,
        menuClassName
    },
        children
    );
};

//make these easily accessible/bundled on the DropDownButton
DropDownButton.MenuHeader = MenuHeader;
DropDownButton.MenuItem = MenuItem;
DropDownButton.MenuDivider = MenuDivider;
DropDownButton.displayName = 'DropDownButton';

export default DropDownButton;
